import { createContext } from 'react';
import { Maybe } from '@csp/csp-common-model';
import { EventProperties } from '../model/EventProperties';

export type AnalyticsAPI = {
  isEnabled: boolean;
  isInitialized: boolean;
  track: (eventName: string, eventProps?: EventProperties) => Promise<void>;
  page: (pageName: string, pageProps?: EventProperties) => Promise<void>;
};

export const AnalyticsContext = createContext<Maybe<AnalyticsAPI>>(undefined);
